import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DetailOverviewStack({ children }) {
    return _jsx("div", { className: "flex flex-col gap-3", children: children });
}
export function DetailOverviewCard({ title, children, }) {
    return (_jsxs("div", { className: "flex flex-col gap-2.5 border border-[#d1d5dc] bg-white p-[14px]", children: [_jsx("h3", { className: "m-0 text-[16px] font-semibold leading-6 tracking-[-0.31px] text-[#0a0a0a]", children: title }), children] }));
}
export function DetailOverviewBody({ children }) {
    return _jsx("div", { className: "text-[14px] leading-5 text-[#4a5565]", children: children });
}
